import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';

function* fetchFactoryArea() {
  try {
    const { data } = yield call(api.get, {
      route: `factoryArea`,
    });
    console.log(data);
    const factoryArea = data;
    yield put(Actions.setFactoryArea({ factoryArea }));
  } catch (err) {
    console.warn(err); // Handle exception
  }
}

function* fetchFactoryAreaDetailsById(id) {
  try {
    const { data } = yield call(api.get, {
      route: `factoryArea/${id.id}`,
    });
    console.log(data);
    const factoryAreaDetails = data;
    yield put(Actions.setFactoryAreaDetails({ factoryAreaDetails }));
  } catch (err) {
    console.warn(err); // Handle exception
  }
}

export default function* rootSaga() {
  yield all([takeLatest(ActionTypes.FETCH_FACTORY_AREA, fetchFactoryArea)]);
  yield all([
    takeLatest(
      ActionTypes.FETCH_FACTORY_AREA_DETAILS,
      fetchFactoryAreaDetailsById
    ),
  ]);
}
